export type UploadFileToS3Params = {
  file: File;
  filename?: string;
  bucketType?: S3BucketType;
};

type S3BucketType = "Afterpay" | "Cash";

export async function uploadFile({
  file,
  filename,
  bucketType = "Afterpay",
}: UploadFileToS3Params): Promise<string> {
  // Create a FormData object to store the file
  const formData = new FormData();
  formData.append("file", file);
  if (filename) {
    formData.append("filename", filename);
  }

  formData.append("bucketType", bucketType);

  const response = await fetch("/api/upload-file", {
    method: "POST",
    body: formData,
  });

  const { url, message } = await response.json();

  if (!response.ok) throw new Error(message);

  return url;
}
